<template>
  <div>
    <v-btn
      v-if="!hide_button"
      :icon="!button_text"
      @click.stop="open_dialog"
    >
      <div v-if="!!button_text">{{ button_text }}</div>
      <v-icon v-else>{{ custom_icon || 'mdi-plus'}}</v-icon>
    </v-btn>
    <ModalDialogForm
      v-if="open || show_modal_dialog"
      title="New property"
      :showModalDialog="open || show_modal_dialog"
      :fields_to_collect="JSON.parse(JSON.stringify(fields))"
      :submit_button_text="$vuetify.lang.translator('dialog.save')"
      :clear_button_text="$vuetify.lang.translator('dialog.cancel')"
      validate
      @clear="hide_dialog"
      @close-dialog="hide_dialog"
      @submit="submit_action"
      :loading="loading"
      return_object
    />
  </div>
</template>
  
<script>
  import ModalDialogForm from '@/components/explorer/ModalDialog'
  export default {
    components: {
      ModalDialogForm
    },
      
    name: 'AddFormItem',
      
    props: {
      open: Boolean,
      fields: {default: () => ([[]])},
      custom_icon: {default: 'mdi-plus'},
      hide_button: Boolean,
      button_text: String,
      roles: {default: ()=>({})},
    },
      
    data: () => ({
      loading: false,
      show_modal_dialog: false,
    }),
      
    computed: {
      
    },
      
    mounted() {
    },
      
    methods: {
      open_dialog() {
        this.show_modal_dialog = true;
      },

      hide_dialog() {
        this.show_modal_dialog = false;
        this.$emit('close');
      },

      submit_action(form) {
        this.$emit('submit',form);
        this.hide_dialog();
      },
    },
  
    watch: {
    },
  }
</script>